import React from "react";
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import themeLarge from "../ThemeLarge";
import { Link, useNavigate } from "react-router-dom";
import { FaRegCalendarAlt } from "react-icons/fa";

class RandomBlogView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      randomBlogs: [],
      isMobile: window.innerWidth <= 768,
    };
  }

  async componentDidMount() {
    window.addEventListener("resize", this.updateWindowSize);
    const db = getFirestore();
    const q = query(
      collection(db, "blogs"),
      where("status", "==", "published")
    );

    try {
      const querySnapshot = await getDocs(q);
      let allBlogs = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      // ❗ Filter out the current blog
      const currentSlug = this.props.currentSlug;
      allBlogs = allBlogs.filter((blog) => blog.slug !== currentSlug);

      let selectedBlogs = [];

      if (allBlogs.length >= 2) {
        // Shuffle and pick 2
        const shuffled = allBlogs.sort(() => 0.5 - Math.random());
        selectedBlogs = shuffled.slice(0, 2);
      } else if (allBlogs.length === 1) {
        // Only one blog left
        selectedBlogs = [allBlogs[0]];
      }
      // else: 0 blogs → leave selectedBlogs empty

      this.setState({ randomBlogs: selectedBlogs });
    } catch (error) {

    }
  }

  // Remove event listener when the component unmounts to avoid memory leaks
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowSize);
  }

  handleCardClick = (slug) => {
    const { navigate } = this.props;
    navigate(`/blogs/${slug}`);
  };

  render() {
    const { randomBlogs, isMobile } = this.state;

    // ⚡ If no blogs, don't render anything
    if (randomBlogs.length === 0) {
      return null;
    }

    return (
      <div className="container mt-4">
        <h3
          className="mb-4"
          style={{
            fontFamily: "Kumbh Sans",
            fontSize: themeLarge.fontSize.h2,
            color: themeLarge.colors.text,
            fontWeight: "600",
          }}
        >
          More from Ibtehaz
        </h3>
        <div className="row">
          {randomBlogs.map((blog) => (
            <div key={blog.id} className="col-md-6 mb-4">
              <div
                style={{
                  padding: "20px",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  background: themeLarge.colors.secondary,
                  cursor: "pointer",
                }}
                onClick={() => this.handleCardClick(blog.slug)}
              >
                {blog.coverPhoto && (
                  <div
                    style={{
                      width: "100%",
                      aspectRatio: "16 / 9", // ✅ Always rectangle
                      overflow: "hidden",
                      borderRadius: "8px",
                      boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                      marginBottom: "12px",
                    }}
                  >
                    <img
                      src={blog.coverPhoto}
                      alt="Blog Cover"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover", // ✅ fill square perfectly
                        display: "block",
                      }}
                    />
                  </div>
                )}

                <p
                  style={{
                    fontSize: themeLarge.fontSize.h3,
                    fontWeight: "700",
                    fontFamily: "Merriweather",
                  }}
                >
                  {blog.title}
                </p>
                <p
                  style={{
                    color: "gray",
                    fontSize: themeLarge.fontSize.body,
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    fontFamily: "Kumbh Sans",
                  }}
                >
                  {blog.excerpt}
                </p>

                <p
                  style={{
                    color: "gray",
                    fontSize: themeLarge.fontSize.small,
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    fontFamily: "Kumbh Sans",
                  }}
                >
                  <FaRegCalendarAlt />
                  {blog.createdAt
                    ? new Date(
                      blog.createdAt.seconds * 1000
                    ).toLocaleDateString("en-US", {
                      month: "short",
                      day: "2-digit",
                      year: "numeric",
                    })
                    : "Unknown Date"}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

// Higher-order component to use navigation
function withNavigation(Component) {
  return function Wrapper(props) {
    const navigate = useNavigate();
    return <Component {...props} navigate={navigate} />;
  };
}

export default withNavigation(RandomBlogView);
